// eslint-disable-next-line import/prefer-default-export
export enum AuthCamera {
  Head = "head",
  Torsos = "torsos",
  Legs = "legs",
  Shoes = "shoes",
  Root = "root",
}
